module.exports = __webpack_public_path__ + "img/661.537cc44c.png";